module.exports = __webpack_public_path__ + "img/ico-circle_arrow.e982a5f8.svg";